import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createApolloFetch } from 'apollo-fetch';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const qaUri = 'https://nuke-qa.internal.cleartax.co/graphql';
const prodUri = 'https://nuke-prod.internal.cleartax.co/graphql';

export const uri =
  publicRuntimeConfig.env === 'development' || publicRuntimeConfig.env === 'qa'
    ? qaUri
    : prodUri;

const httpLink = createHttpLink({
  uri,
  headers: { 'x-source-category': 'web' },
});

export const client = new ApolloClient({
  ssrMode: true,
  link: httpLink,
  cache: new InMemoryCache(),
});

export const apolloFetch = createApolloFetch({
  uri,
});



// WEBPACK FOOTER //
// ./configs/apollo.js